import _extends from "@babel/runtime/helpers/esm/extends";

/* eslint-disable import/order */
// This file has been generated using @svgr/cli.
// Run "yarn generate:icons" in order to generate the files for new icons.
import * as React from 'react';
import styled from 'styled-components';
import { size, color } from 'styled-system';

var SvgComponent = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39 13.01v-6c-6.356.117-11.535 1.373-15.547 3.749A5 5 0 0 0 21 15.062v3.774c.264-.27.55-.519.86-.746 4.427-3.247 10.148-4.934 17.14-5.08Zm0 2c-6.585.144-11.896 1.714-15.957 4.693A5 5 0 0 0 21 23.735V36a7 7 0 0 1-7 7h-2a5 5 0 0 1-5-5v-.188a5.5 5.5 0 0 1 4.596-5.425L19 31.153V15.062a7 7 0 0 1 3.434-6.024C26.992 6.34 32.85 5 40 5a1 1 0 0 1 1 1v24a7 7 0 0 1-7 7h-2a5 5 0 0 1-5-5v-.188a5.5 5.5 0 0 1 4.596-5.425L39 25.153V15.01ZM19 33.18l-7.075 1.18A3.5 3.5 0 0 0 9 37.812V38a3 3 0 0 0 3 3h2a5 5 0 0 0 5-5v-2.82Zm20-6-7.075 1.18A3.5 3.5 0 0 0 29 31.812V32a3 3 0 0 0 3 3h2a5 5 0 0 0 5-5v-2.82Z",
    fill: "currentColor"
  }));
};

var SvgMusic = styled(SvgComponent).withConfig({
  displayName: "Music__SvgMusic",
  componentId: "sc-xd0gwh-0"
})(["", " ", ""], size, color);
export default SvgMusic;